<!-- <template>
	<div class="item-view" v-if="item">
		<template v-if="item">
			<div class="item-view-header">
				<a :href="item.url" target="_blank">
					<h1>{{ item.evpaName }}</h1>
				</a>
				<span v-if="item.url" class="host">
					({{ item.url | host }})
				</span>
				<p class="meta">
					{{ item.evpaBIBNo }}
					| {{ item.evpaGender }} --
					{{ item.evpaCreatedTime | timeAgo }} ago
				</p>
			</div>
			<div class="item-view-comments">
				<p class="item-view-comments-header">
					{{ item.kids ? item.descendants + ' comments' : 'No comments yet.' }}
					<spinner :show="loading"></spinner>
				</p>
				<ul v-if="!loading" class="comment-children">
					<comment v-for="id in item.kids" :key="id" :id="id"></comment>
				</ul>
			</div>
		</template>
	</div>
</template>
 -->
<template>
	<li class="news-item" v-if="enabled">
		<span class="score">{{ item.evpaBIBNo }}</span>
		<table style="width:100%">
			<tbody>
				<tr class="heady">
					<td>Status</td>
					<td>{{item.mbsdStatus}}</td>
				</tr>
				<tr>
					<td>Full Name</td>
					<td>{{item.mbsdFullName}}</td>
				</tr>
				<tr>
					<td>Identity Number</td>
					<td>{{item.mbsdIDNumber}}</td>
				</tr>
				
				<tr style="font-size:13px">
					<td>E-mail</td>
					<td>{{ item.mbsdEmail}}</td>
				</tr>
				<tr style="font-size:13px">
					<td>Gender</td>
					<td>{{ item.evpaGender | gender }}</td>
				</tr>
				<tr style="font-size:13px">
					<td>Date of Birth</td>
					<td>{{ item.mbsdBirthDate}}</td>
				</tr>
			</tbody>
		</table>
		<!-- <p>{{item}}</p> -->
		<!-- <span class="title">
			<span>Status : {{item.mbsdStatus}}</span><br/>
			<span>{{item.mbsdFullName}}</span>
		</span>
		<br>
		<span class="meta">
			<span v-if="item.type !== 'job'" class="by">
				{{ item.evpaGender | gender }}
			</span>
			<br/>
			<span class="time"> -->
				<!-- {{ item.evpaCreatedTime | timeAgo }} ago
				 {{item.mbsdIDNumber}}
			</span>
		</span> -->
		<img style="width: 100%;" :src="'https://private.borobudurmarathon.com/view/'+item.mbsdFile"/>
		<br>
		<p class="text-center"><a target="_blank" :href="'https://private.borobudurmarathon.com/view/'+item.mbsdFile">{{item.mbsdFile}}</a></p>
		
		<b-button block variant="primary" style="padding:.5em;margin-top:1em;text-transform:uppercase;letter-spacing:2px;font-weight:800" @click="verifyData">Whitelist</b-button>
	</li>
</template>

<script>
import { timeAgo, gender } from '../util/filters'

export default {
	data () {
		return {
			enabled: true
		}
	},
	name: 'news-item',
	props: ['item'],
	// http://ssr.vuejs.org/en/caching.html#component-level-caching
	serverCacheKey: ({ item: { id, __lastUpdated, time }}) => {
		return `${id}::${__lastUpdated}::${timeAgo(time)}`
	},
	methods:{
		verifyData(){
			this.$store.dispatch('VERIFYDATA', {fileId:this.item.mbsdFile})
				.then(s=>{
					this.enabled = false;
					// console.log(this.item);
				})
				.catch(e=>{
					console.log(e);
				})
			console.log(this.item);
		}
	}
}
</script>

<style lang="stylus">
.news-item
	background-color #fff
	padding 20px 30px 20px 80px
	border-bottom 1px solid #eee
	position relative
	line-height 20px
	.score
		color #ff6600
		font-size 1.1em
		font-weight 700
		position absolute
		top 50%
		left 0
		width 80px
		text-align center
		margin-top -10px
	.meta, .host
		font-size .85em
		color #828282
		a
			color #828282
			text-decoration underline
			&:hover
				color #ff6600
</style>



// WEBPACK FOOTER //
// Grid.vue